import { standardQuerySerializer } from '../../api/serializers';
import { applyQueryConfig, makeCancelable, ServiceHandler } from '../../utils';

const searchConnectorsByTypeHandler = ServiceHandler({
  url: '/api/connector/v1/search',
});
export const searchConnectorsByType = (params: any = {}) =>
  searchConnectorsByTypeHandler({ params });

export const getLegacyConnectors = ServiceHandler({
  url: 'api/connector/v1/connectors/all',
});

export const getConnections = ServiceHandler({
  url: 'api/connector/v1/connections',
});

const getConnectorScoreHandler = makeCancelable(
  ServiceHandler({
    url: '/api/connector/v1/:connectorType/getLatestScore/:connectorId',
  })
);
export const getConnectorScore = ({ connectorType, connectorId }: any) =>
  getConnectorScoreHandler(connectorType, connectorId);

const getActionListParamSchema = [
  { path: 'page' },
  { path: 'size' },
  { path: 'search' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      switch (orderBy) {
        case 'score':
        case 'maxScore':
        case 'isCompleted':
          return `${orderBy},${order}`;
        default:
          return orderBy ? `${orderBy}.keyword,${order}` : null;
      }
    },
  },
];
const getActionListHandler = makeCancelable(
  ServiceHandler({
    url: '/api/connector/v1/:connectorType/getActionList/:connectorId',
    paramsSerializer: (params: any) =>
      standardQuerySerializer(
        applyQueryConfig(getActionListParamSchema, params)
      ),
  })
);
export const getActionList = ({ connectorType, connectorId, ...params }: any) =>
  getActionListHandler(connectorType, connectorId, { params });

const getConnectorStatusHandler = ServiceHandler({
  url: '/api/connector/v1/connections/:connectorId/status',
});
export const getConnectorStatus = ({ connectorId }: any) =>
  getConnectorStatusHandler(connectorId);

/**
 * New location src/apis/connectors/connectors.api.ts
 * @deprecated
 */
export const deleteConnectorById = ServiceHandler({
  url: '/api/connector/v1/:connectorId',
  method: 'delete',
});

const getConnectorScoreHistoryHandler = makeCancelable(
  ServiceHandler({
    url: '/api/connector/v1/:connectorType/getScoresHistory/:connectorId',
  })
);
export const getConnectorScoreHistory = ({
  connectorType,
  connectorId,
  days,
}: any) =>
  getConnectorScoreHistoryHandler(connectorType, connectorId, {
    params: { days },
  });

const getShortlistActionsHandler = makeCancelable(
  ServiceHandler({
    url: '/api/connector/v1/:connectorType/getShortlistActions/:connectorId',
  })
);
export const getShortlistActions = ({ connectorType, connectorId }: any) =>
  getShortlistActionsHandler(connectorType, connectorId);

const getConnectorHandler = makeCancelable(
  ServiceHandler({ url: '/api/connector/v1/connections' })
);
export const getConnector = (params: any = {}) => getConnectorHandler({ params });

const securityStudioConnectHandler = ServiceHandler({
  url: 'api/connector/v1/connections',
  method: 'post',
});
export const securityStudioConnect = (_params: any = {}, data?: any) =>
  securityStudioConnectHandler({ data });

const wizerConnectHandler = ServiceHandler({
  url: '/api/connector/v1/wizer/add',
  method: 'post',
});
export const wizerConnect = (params: any = {}, data?: any) =>
  wizerConnectHandler({ params, data });

const qualysConnectHandler = ServiceHandler({
  url: '/api/connector/v1/connections/',
  method: 'post',
});
export const qualysConnect = (_params: any = {}, data?: any) =>
  qualysConnectHandler({ data });

const getConnectedConnectorsHandler = makeCancelable(
  ServiceHandler({ url: '/api/connector/v1/account/:accountId' })
);
export const getConnectedConnectors = ({ accountId }: any) =>
  getConnectedConnectorsHandler(accountId);

export const getAWSregions = makeCancelable(
  ServiceHandler({ url: '/api/connector/v1/aws/regions' })
);

const connectAWSHandler = makeCancelable(
  ServiceHandler({ url: 'api/connector/v1/connections', method: 'post' })
);
export const connectAWS = (_params: any = {}, data?: any) =>
  connectAWSHandler({ data });

const leenOrgCreateHandler = ServiceHandler({
  url: 'api/connector/v1/leen/organization',
  method: 'post',
});
export const leenOrgCreate = (_params: any = {}, data?: any) =>
  leenOrgCreateHandler({ data });

const leenTokenCreateHandler = ServiceHandler({
  url: 'api/connector/v1/leen/invite-token',
  method: 'post',
});
export const leenTokenCreate = (_params: any = {}, data?: any) =>
  leenTokenCreateHandler({ data });

const storeLeenConnectionResponseHandler = ServiceHandler({
  url: 'api/connector/v1/connections',
  method: 'post',
});
export const storeLeenConnectionResponse = (_params: any = {}, data?: any) =>
  storeLeenConnectionResponseHandler({ data });

/**
 * Retrieves the list of connectors from the Leen API.
 *
 * @returns {Promise} A promise that resolves to the list of connections.
 */
export const getConnectionsList = ServiceHandler({
  url: 'api/connector/v1/leen/connectors',
  method: 'get',
});

const deleteConnectionHandler = ServiceHandler({
  url: 'api/connector/v1/connections/:id',
  method: 'delete',
});
export const deleteConnection = ({ id }: any) => deleteConnectionHandler(id);

const getOAuthMetadataHandler = ServiceHandler({
  url: 'api/connector/v1/connectors/:connectorType/oauth/metadata',
  method: 'get',
});
export const getOAuthMetadata = ({ connectorType }: any) =>
  getOAuthMetadataHandler(connectorType);
